(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

window.addEventListener('load', function () {
    // Create an immediately invoked functional expression to wrap the code
    (function () {

        // Define constructor
        var YTPlayer = function YTPlayer() {

            // Create global element references
            this.ytplayer = null;

            // Define options defaults
            var defaults = {
                key: '__API_KEY_NEEDED__', // YouTube API Key
                part: 'snippet,contentDetails',
                url: 'https://www.googleapis.com/youtube/v3/videos',
                firstVideoId: '__FIRST_YOUTUBE_VIDEO_ID_NEEDED__',
                ids: '__YOUTUBE_IDS_NEEDED__',
                playlistMainContainerId: '__PLAYLIST_MAIN_CONTAINER_DIV_ID__',
                playerYoutubeId: '__YOUTUBE_PLAYER_ID__',
                youtubePlayerContainerId: '__YOUTUBE_PLAYER_CONTAINER_DIV_ID__',
                youtubeVideoControlsPlaylistWrapperId: '__YOUTUBE_VIDEO_CONTROLS_PLAYLIST_CONTAINER_DIV_ID__',
                youtubePlaylistWrapperId: '__YOUTUBE_PLAYLIST_CONTAINER_DIV_ID__',
                maxResults: 6,
                autoLoad: 0 // 0 = false, 1 = true
            };

            // Create options by extending defaults with the passed in arguments
            if (arguments[0] && _typeof(arguments[0]) === 'object') {
                this.options = extendDefaults(defaults, arguments[0]);
            }

            buildOut.call(this);
        };

        // Private Methods

        // Utility method to extend defaults with user options
        function extendDefaults(source, properties) {
            var property;

            for (property in properties) {
                if (properties.hasOwnProperty(property)) {
                    source[property] = properties[property];
                }
            }

            return source;
        }

        function adjustDivWidth(playlistMainContainerId, playerYoutubeContainerId, youtubePlayerContainerId) {
            var parentContainerWidth = jQuery('#' + playlistMainContainerId).parent().width();

            if (parentContainerWidth < 904) {
                jQuery('#' + playerYoutubeContainerId).addClass('displayMobile');
                jQuery('#' + youtubePlayerContainerId).addClass('displayMobile');
            }
        }

        function durationConversion(duration) {
            var hours = '';
            var minutes = '';
            var seconds = '';
            var hours_exists = false;

            if (duration.indexOf('H') > -1) {
                hours = duration.substring(duration.lastIndexOf('PT') + 2, duration.lastIndexOf('H'));

                hours_exists = true;
            }

            if (hours_exists) {
                if (hours.length == 1) hours = '0' + hours;

                hours = hours + ':';

                minutes = duration.substring(duration.lastIndexOf('H') + 1, duration.lastIndexOf('M'));
            } else {
                minutes = duration.substring(duration.lastIndexOf('PT') + 2, duration.lastIndexOf('M'));
            }

            if (minutes.length == 1) minutes = '0' + minutes;

            minutes = minutes + ':';

            seconds = duration.substring(duration.lastIndexOf('M') + 1, duration.lastIndexOf('S'));

            if (seconds.length == 1) seconds = '0' + seconds;

            var time = hours + minutes + seconds;

            return time;
        }

        function mainVid(id, firstLoad, playerYoutubeContainerId) {
            jQuery('#' + playerYoutubeContainerId).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + id + '?autoplay=' + firstLoad + '&rel=0" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" style="height: 409.5px;"></iframe>');
        }

        function currentVidInfo(title, duration, youtubeVideoControlsPlaylistWrapperId) {
            jQuery('#' + youtubeVideoControlsPlaylistWrapperId).html('<div class="td_video_stop_play_control">\n                    <a class="td-sp-video-play td-sp td_youtube_control"></a>\n                </div>\n                <div class="td_current_video_play_title_youtube td_video_title_playing">' + title + '</div>\n                <div class="td_current_video_play_time_youtube td_video_time_playing">' + duration + '</div>');
        }

        function resultsLoop(data, divIds) {
            var currentTitle = data.items[0].snippet.title;
            var currentDuration = durationConversion(data.items[0].contentDetails.duration);
            var youtubeVideoControlsPlaylistWrapperId = divIds['youtubeVideoControlsPlaylistWrapperId'];
            var youtubePlayerContainerId = divIds['youtubePlayerContainerId'];
            var youtubePlaylistWrapperId = divIds['youtubePlaylistWrapperId'];

            currentVidInfo(currentTitle, currentDuration, youtubeVideoControlsPlaylistWrapperId);

            var current_item = '';
            var videosContainer = jQuery('#' + youtubePlayerContainerId + ' #' + youtubePlaylistWrapperId);

            jQuery.each(data.items, function (i, item) {
                var thumb = item.snippet.thumbnails.default.url;
                var title = item.snippet.title;
                var duration = durationConversion(item.contentDetails.duration);
                var vid = item.id;

                if (i == 0) current_item = ' td_video_currently_playing';else current_item = '';

                videosContainer.append('<a class="td_click_video td_click_video_youtube' + current_item + '" data-key="' + vid + '">\n                        <div class="td_video_thumb"><img src="' + thumb + '" alt="Video thumbnail"></div>\n                        <div class="td_video_title_and_time">\n                            <div class="td_video_title">' + title + '</div>\n                            <div class="td_video_time">' + duration + '</div> \n                        </div>\n                    </a>');
            });

            videosContainer.on('click', 'a', function () {
                var id = jQuery(this).attr('data-key');
                var currentTitle = jQuery('div.td_video_title', this).text();
                var currentDuration = jQuery('div.td_video_time', this).text();

                jQuery('.td_video_currently_playing').removeClass('td_video_currently_playing');
                jQuery(this).addClass('td_video_currently_playing');

                mainVid(id, 1, divIds['playerYoutubeContainerId']);
                currentVidInfo(currentTitle, currentDuration, youtubeVideoControlsPlaylistWrapperId);
            });
        }

        function loadPlayer(key, videoIds, firstVideoId, url, maxResults, playerYoutubeContainerId, autoLoad, divIds) {
            var key = key;
            var URL = url;

            var params = {
                part: 'snippet,contentDetails',
                key: key,
                maxResults: maxResults,
                id: videoIds
            };

            function loadVids() {
                jQuery.getJSON(URL, params, function (data) {
                    mainVid(firstVideoId, autoLoad, playerYoutubeContainerId);
                    resultsLoop(data, divIds);
                });
            }

            loadVids();
        }

        function buildOut() {
            var firstVideoId = this.options.firstVideoId;
            var videoIds = this.options.videoIds;
            var key = this.options.key;
            var url = this.options.url;
            var maxResults = this.options.maxResults;
            var autoLoad = this.options.autoLoad;
            var playlistMainContainerId = this.options.playlistMainContainerId;

            var divIds = [];
            divIds['playerYoutubeContainerId'] = this.options.playerYoutubeContainerId;
            divIds['youtubePlayerContainerId'] = this.options.youtubePlayerContainerId;
            divIds['youtubeVideoControlsPlaylistWrapperId'] = this.options.youtubeVideoControlsPlaylistWrapperId;
            divIds['youtubePlaylistWrapperId'] = this.options.youtubePlaylistWrapperId;

            // Create content area
            jQuery('#' + playlistMainContainerId).html('<div class="td_block_wrap td_block_video_playlist">\n\n                    <div class="td_block_inner">\n\n                        <div class="td_video_playlist_column_3">\n\n                            <div class="td_video_playlist_title">\n\n                                <div class="td_video_title_text">Watch now</div>\n\n                            </div>\n\n                            <div class="td_wrapper_video_playlist">\n\n                                <div id="' + divIds['playerYoutubeContainerId'] + '" class="td_wrapper_player td_wrapper_playlist_player_youtube"></div>\n\n                                <div id="' + divIds['youtubePlayerContainerId'] + '" class="td_container_video_playlist">\n\n                                    <div id="' + divIds['youtubeVideoControlsPlaylistWrapperId'] + '" class="td_video_controls_playlist_wrapper"></div>\n\n                                    <div id="' + divIds['youtubePlaylistWrapperId'] + '" class="td_playlist_clickable td_add_scrollbar_to_playlist"></div>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                </div>');

            // Load Player
            loadPlayer(key, videoIds, firstVideoId, url, maxResults, divIds['playerYoutubeContainerId'], autoLoad, divIds);

            // Adjust Player Div Width
            adjustDivWidth(playlistMainContainerId, divIds['playerYoutubeContainerId'], divIds['youtubePlayerContainerId']);
        }

        // Public Methods
        YTPlayer.prototype.display = function () {
            // Build out our YTPlayer
            buildOut.call(this);

            /*
            * After adding elements to the DOM, use getComputedStyle
            * to force the browser to recalc and recognize the elements
            * that we just added. This is so that CSS animation has a start point
            */
            window.getComputedStyle(this.ytplayer).height;
        };

        // Make accessible globally
        window.YTPlayer = YTPlayer;
    })();
});

},{}]},{},[1]);
